<script>
import 'bulma/css/bulma.css'
import { hasAdminRole } from '@/api/Utilities.js'
import { getMyUserId } from '@/api/FirebaseUserWrapper.js'
import * as constant from '@/constant/constant.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAnalytics, logEvent } from 'firebase/analytics'
const analytics = getAnalytics(firebaseApp)
require('../../css/style.css')
export default {
  data () {
    return {
      userId: '',
      title: constant.DEFAULT_DOMAIN_TITLE
    }
  },
  async created () {
    this.userId = await getMyUserId()
    document.title = 'チーム | ' + this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', 'チーム | ' + this.title)
    // =================== GOOGLE ANALYTICS ===================
    if (hasAdminRole(this.userId)) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'teams/Teams')
    }
  },
  beforeDestroy () {
    document.title = this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', this.title)
  },
  methods: {
  }
}
</script>
<style scoped>
.devteam {
  margin: auto;
  max-width: 1024px;
  padding: 1.0rem;
}
</style>
<template>
  <div class="devteam">
    <span class="text has-text-link has-text-weight-bold is-size-5">開発メンバー紹介</span>
      <article class="media">
        <figure class="media-left">
          <p class="image is-64x64">
            <img class="is-rounded" src="./img/shige.png">
          </p>
        </figure>
        <div class="media-content">
          <div class="content">
            <p>
              <a href="https://twitter.com/SU_adnyer" target="_blank">
              <strong>SHIGETA</strong></a> <small>@PL</small>
              <br>
              企画＋開発担当<br>
            </p>
          </div>
        </div>
      </article>

      <article class="media">
        <figure class="media-left">
          <p class="image is-64x64">
            <img class="is-rounded" src="./img/morig.png">
          </p>
        </figure>
        <div class="media-content">
          <div class="content">
            <p>
              <strong>もりぐち</strong> <small>@Engnieer</small>
              <br>
              Vue開発のリード担当<br>
            </p>
          </div>
        </div>
      </article>

      <article class="media">
        <figure class="media-left">
          <p class="image is-64x64">
            <img class="is-rounded" src="./img/masu.png">
          </p>
        </figure>
        <div class="media-content">
          <div class="content">
            <p>
              <a href="https://hack-le.com/" target="_blank">
              <strong>tama</strong></a><small>@Engnieer</small>
              <br>
              Firebase開発のリード担当<br>
            </p>
          </div>
        </div>
      </article>
      <hr>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/teams/Teams.vue